import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
import MenuButton from '../MenuButton/MenuButton';
import AudioSubtitlesMenuContent from '../AudioSubtitlesMenuContent/AudioSubtitlesMenuContent';

/* Styles */
import './AudioSubtitleButton.scss';

function AudioSubtitleButton({
  audioTracks,
  onSelectAudio,
  subtitleTracks,
  onSelectSubtitle,
  onDisableSubtitles,
  tooltip,
  subtitlesTitle,
  audioTitle,
  getLanguageLabel,
}) {
  return (
    <MenuButton
      buttonContent={<Icon name="subtitles" />}
      className="dtv-common-c-audio-subtitle-button-v2"
      tooltip={tooltip}
    >
      <AudioSubtitlesMenuContent
        audioTracks={audioTracks}
        onSelectAudio={onSelectAudio}
        subtitleTracks={subtitleTracks}
        onSelectSubtitle={onSelectSubtitle}
        onDisableSubtitles={onDisableSubtitles}
        audioTitle={audioTitle}
        subtitlesTitle={subtitlesTitle}
        getLanguageLabel={getLanguageLabel}
      />
    </MenuButton>
  );
}

const trackShape = PropTypes.shape({
  name: PropTypes.string,
  isSelected: PropTypes.bool,
});

AudioSubtitleButton.propTypes = {
  audioTracks: PropTypes.arrayOf(trackShape),
  onSelectAudio: PropTypes.func,
  subtitleTracks: PropTypes.arrayOf(trackShape),
  onSelectSubtitle: PropTypes.func,
  onDisableSubtitles: PropTypes.func,
  tooltip: PropTypes.string,
  subtitlesTitle: PropTypes.string,
  audioTitle: PropTypes.string,
  getLanguageLabel: PropTypes.func,
};

AudioSubtitleButton.defaultProps = {
  audioTracks: [],
  onSelectAudio() {},
  subtitleTracks: [],
  onSelectSubtitle() {},
  onDisableSubtitles() {},
  tooltip: '',
  subtitlesTitle: '',
  audioTitle: '',
  getLanguageLabel() {},
};

export default AudioSubtitleButton;
